import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const ForgotPasswordWrapper = withConfig(theme => styled('div', { label: 'ForgotPasswordWrapper' })`
    background-color: ${theme.star.accountDrawer.bgColor};
    display: flex;
    flex-direction: column;
    height: 100%;
`);

export const ForgotPasswordForm = styled('div', { label: 'ForgotPasswordForm' })`
    margin: 16px;
`;

export const ForgotPasswordBtnWrapper = styled(Button, { label: 'ForgotPasswordBtnWrapper' })`
    display: block;
    margin-top: 16px;
    width: 100%;
`;

export const ForgotPasswordDescription = withConfig(theme => styled('p', { label: 'ForgotPasswordDescription' })`
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.regular};
    margin: 0 0 16px 0;
    line-height: 1.3334;
`);

export const AlignBottomWrapper = styled('div', { label: 'AlignBottomWrapper' })`
    margin: auto 0 0 0;
`;
